var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.7 91.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#baa1de;}.cls-2{fill:#fff;}.cls-3{fill:#ffed4a;}.cls-4{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.66,14.89a35.68,35.68,0,0,0-35.24,37c.65,18.34,2.1,37.6,5.34,38.76,2.73,1,16.75,1.1,31.77.93a40.57,40.57,0,0,0,40.14-42c-.58-16.54-1.57-32-3.2-33C90.64,15.37,71.9,14.69,53.66,14.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 56.91,
    cy: 53.75,
    r: 30.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 39.11,
    cy: 74.88,
    r: 10.96,
    transform: "translate(-25.83 20.85) rotate(-22.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 56.5,
    cy: 53.94,
    r: 12.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1,54.15c.66-.33,9.24,4,29.05-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.31,11.23c2,.33,20.14,3.64,32.35,20.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.18,1S59,14.64,56.91,23.67"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic6);
export default __webpack_public_path__ + "static/media/Pic6.98f17d88597fe52b972ecbbea34da0e0.svg";
export { ForwardRef as ReactComponent };